import { create } from "zustand";
import { PDA1123_R01RecoverItem, PDA1123_R01ScanResult } from "./PDA1123_R01Dto";

export interface PDA1123_R01Store {
  loading: boolean;
  lotInput: string;
  scanResult: PDA1123_R01ScanResult | null;
  recoverList: PDA1123_R01RecoverItem[];
  setLoading: (loading: boolean) => void;
  setLotInput: (lotInput: string) => void;
  setScanResult: (result: PDA1123_R01ScanResult | null) => void;
  addRecover: (item: PDA1123_R01RecoverItem) => boolean;
  removeRecover: (lotNo: string) => void;
  clearRecover: () => void;
  reset: () => void;
}

const usePDA1123_R01Store = create<PDA1123_R01Store>((set, get) => ({
  loading: false,
  lotInput: "",
  scanResult: null,
  recoverList: [],
  setLoading: (loading) => set({ loading }),
  setLotInput: (lotInput) => set({ lotInput }),
  setScanResult: (scanResult) => set({ scanResult }),
  addRecover: (item) => {
    if (get().recoverList.some((target) => target.lotNo === item.lotNo)) return false;
    set((state) => ({ recoverList: [...state.recoverList, item] }));
    return true;
  },
  removeRecover: (lotNo) =>
    set((state) => ({
      recoverList: state.recoverList.filter((target) => target.lotNo !== lotNo),
    })),
  clearRecover: () => set({ recoverList: [] }),
  reset: () => set({ loading: false, lotInput: "", scanResult: null, recoverList: [] }),
}));

export default usePDA1123_R01Store;
